import React from 'react'

const TrackingIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 66 66"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#1975c9"
                        d="M41.75 6.92v52.17c0 2.67-2.16 4.83-4.83 4.83H8.72c-2.67 0-4.83-2.16-4.83-4.83V6.92c0-2.67 2.16-4.83 4.83-4.83h28.2c2.67 0 4.83 2.16 4.83 4.83z"
                        opacity={1}
                        data-original="#656d78"
                        className=""
                    />
                    <path
                        d="M36.92 64.4H8.72c-2.93 0-5.31-2.38-5.31-5.31V6.92c0-2.93 2.38-5.31 5.31-5.31h28.2c2.93 0 5.31 2.38 5.31 5.31v52.17a5.32 5.32 0 0 1-5.31 5.31zM8.72 2.57c-2.4 0-4.35 1.95-4.35 4.35v52.17c0 2.4 1.95 4.35 4.35 4.35h28.2c2.4 0 4.35-1.95 4.35-4.35V6.92c0-2.4-1.95-4.35-4.35-4.35z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        fill="#c5dcf1"
                        d="M37.89 8.85v48.3c0 1.6-1.3 2.9-2.9 2.9H10.65c-1.6 0-2.9-1.3-2.9-2.9V8.85c0-1.6 1.3-2.9 2.9-2.9H13c.57 0 1.09.34 1.32.86l.86 1.93c.23.52.75.86 1.32.86h12.61c.57 0 1.09-.34 1.32-.86l.86-1.93c.23-.52.75-.86 1.32-.86h2.36c1.62 0 2.92 1.3 2.92 2.9z"
                        opacity={1}
                        data-original="#f4f6f8"
                        className=""
                    />
                    <path
                        fill="#d7dadf"
                        d="M37.89 55.71v1.45c0 1.6-1.3 2.9-2.9 2.9H10.66c-1.6 0-2.9-1.3-2.9-2.9v-1.45c0 1.6 1.29 2.9 2.9 2.9H35c1.59-.01 2.89-1.3 2.89-2.9z"
                        opacity={1}
                        data-original="#d7dadf"
                    />
                    <path
                        d="M34.99 60.53H10.65c-1.86 0-3.38-1.52-3.38-3.38V8.85c0-1.86 1.52-3.38 3.38-3.38H13c.76 0 1.45.45 1.76 1.14l.86 1.93c.16.35.5.57.88.57h12.61c.38 0 .73-.22.88-.57l.86-1.93c.31-.69 1-1.14 1.76-1.14h2.36c1.86 0 3.38 1.52 3.38 3.38v48.3c.02 1.87-1.5 3.38-3.36 3.38zM10.65 6.43c-1.33 0-2.42 1.08-2.42 2.42v48.3c0 1.33 1.08 2.42 2.42 2.42h24.34c1.33 0 2.42-1.08 2.42-2.42V8.85c0-1.33-1.08-2.42-2.42-2.42h-2.36c-.38 0-.73.22-.88.57l-.86 1.93c-.31.69-1 1.14-1.76 1.14H16.51c-.76 0-1.45-.45-1.76-1.14L13.89 7a.964.964 0 0 0-.88-.57z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        d="M27.84 6.32h-6.29c-.27 0-.48-.22-.48-.48s.22-.48.48-.48h6.29c.27 0 .48.22.48.48s-.22.48-.48.48z"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <circle
                        cx="18.29"
                        cy="5.84"
                        r=".48"
                        fill="#000000"
                        opacity={1}
                        data-original="#000000"
                        className=""
                    />
                    <path
                        fill="#fdcd56"
                        d="M59.1 54.13H44.05V32.26h12.09c.71 0 1.35.4 1.66 1.03l4.12 8.38c.12.25.19.53.19.82v8.63c0 1.66-1.35 3.01-3.01 3.01zM20.41 54.13h23.64v-7.34H16.46v3.39c0 2.18 1.77 3.95 3.95 3.95z"
                        opacity={1}
                        data-original="#fdcd56"
                    />
                    <path
                        fill="#e3b84d"
                        d="M62.11 49.66v1.45c0 1.67-1.35 3.01-3.01 3.01H44.04v-1.45h15.05c1.67.01 3.02-1.34 3.02-3.01zM44.04 52.68v1.45H18.93c-1.36 0-2.47-1.11-2.47-2.47v-1.45c0 1.36 1.11 2.47 2.47 2.47z"
                        opacity={1}
                        data-original="#e3b84d"
                    />
                    <path
                        fill="#000102"
                        d="M59.1 54.61H44.05a.48.48 0 0 1-.48-.48V32.26c0-.27.22-.48.48-.48h12.09c.9 0 1.7.5 2.09 1.3l4.12 8.37c.16.32.24.67.24 1.03v8.63c0 .93-.36 1.81-1.02 2.47a3.44 3.44 0 0 1-2.47 1.03zm-14.57-.96H59.1c.68 0 1.31-.26 1.79-.74s.74-1.11.74-1.79v-8.63c0-.21-.05-.42-.14-.6l-4.12-8.37c-.23-.47-.7-.76-1.23-.76H44.53z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <path
                        fill="#8c9ffa"
                        d="M59.15 44.08v-1.17a.8.8 0 0 0-.08-.33l-3.42-6.95a.734.734 0 0 0-.66-.41h-7.24c-.41 0-.74.33-.74.74v8.12c0 .41.33.74.74.74h10.66c.4 0 .74-.33.74-.74z"
                        opacity={1}
                        data-original="#8c9ffa"
                    />
                    <path
                        fill="#6e7fed"
                        d="M59.15 44.08c0 .41-.33.74-.74.74H47.75c-.41 0-.74-.33-.74-.74v-1.45c0 .41.33.74.74.74H58.4c.36 0 .65-.25.72-.58.01.04.01.08.01.12z"
                        opacity={1}
                        data-original="#6e7fed"
                    />
                    <path
                        fill="#000102"
                        d="M58.41 45.31H47.75c-.67 0-1.22-.55-1.22-1.22v-8.12c0-.67.55-1.22 1.22-1.22h7.24c.47 0 .89.26 1.1.68l3.42 6.95c.08.17.13.35.13.54v1.17a1.24 1.24 0 0 1-1.23 1.22zM47.75 35.7c-.14 0-.26.12-.26.26v8.12c0 .14.12.26.26.26h10.66c.14 0 .26-.12.26-.26v-1.17c0-.04-.01-.08-.03-.11l-3.42-6.95a.244.244 0 0 0-.23-.14h-7.24z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <circle
                        cx="53.36"
                        cy="55.09"
                        r="4.86"
                        fill="#1975c9"
                        opacity={1}
                        data-original="#656d78"
                        className=""
                    />
                    <path
                        fill="#545c66"
                        d="M58.22 55.09c0 2.68-2.17 4.86-4.86 4.86s-4.86-2.18-4.86-4.86c0-.25.02-.49.06-.72.35 2.34 2.36 4.13 4.8 4.13s4.45-1.8 4.8-4.13c.04.23.06.47.06.72z"
                        opacity={1}
                        data-original="#545c66"
                    />
                    <path
                        fill="#000102"
                        d="M53.36 60.43c-2.95 0-5.34-2.4-5.34-5.34 0-2.95 2.4-5.34 5.34-5.34 2.95 0 5.34 2.4 5.34 5.34s-2.4 5.34-5.34 5.34zm0-9.72c-2.41 0-4.38 1.96-4.38 4.38s1.96 4.38 4.38 4.38 4.38-1.96 4.38-4.38-1.97-4.38-4.38-4.38z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <path
                        fill="#ffffff"
                        d="M53.36 57.08c-1.1 0-1.99-.89-1.99-1.99s.89-1.99 1.99-1.99 1.99.89 1.99 1.99c0 1.09-.9 1.99-1.99 1.99z"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#000102"
                        d="M53.36 57.56c-1.36 0-2.47-1.11-2.47-2.47s1.11-2.47 2.47-2.47 2.47 1.11 2.47 2.47-1.11 2.47-2.47 2.47zm0-3.98c-.83 0-1.51.68-1.51 1.51s.68 1.51 1.51 1.51 1.51-.68 1.51-1.51c-.01-.83-.68-1.51-1.51-1.51zM44.05 54.61H18.93c-1.63 0-2.95-1.32-2.95-2.95v-4.87c0-.27.22-.48.48-.48h27.58c.27 0 .48.22.48.48v7.34c.01.27-.21.48-.47.48zm-27.11-7.33v4.38c0 1.09.89 1.99 1.99 1.99h24.63v-6.37zM53.94 47.24h-2.39c-.27 0-.48-.22-.48-.48s.22-.48.48-.48h2.39a.48.48 0 0 1 0 .96z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <path
                        fill="#ffffff"
                        d="M60.72 50.23h1.39v-3.47h-1.39c-.52 0-.93.42-.93.93v1.6c-.01.52.41.94.93.94z"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#000102"
                        d="M62.11 50.71h-1.36c-.8 0-1.45-.65-1.45-1.45v-1.54c0-.8.65-1.45 1.45-1.45h1.36c.27 0 .48.22.48.48v3.47c0 .28-.21.49-.48.49zm-1.36-3.47a.48.48 0 0 0-.48.48v1.54c0 .27.22.48.48.48h.88v-2.5z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <circle
                        cx="27.16"
                        cy="55.09"
                        r="4.86"
                        fill="#1975c9"
                        opacity={1}
                        data-original="#656d78"
                        className=""
                    />
                    <path
                        fill="#545c66"
                        d="M32.02 55.09a4.859 4.859 0 1 1-9.72 0c0-.25.02-.49.06-.72a4.856 4.856 0 0 0 4.8 4.13c2.44 0 4.45-1.8 4.8-4.13.04.23.06.47.06.72z"
                        opacity={1}
                        data-original="#545c66"
                    />
                    <path
                        fill="#000102"
                        d="M27.16 60.43c-2.95 0-5.34-2.4-5.34-5.34 0-2.95 2.4-5.34 5.34-5.34 2.95 0 5.34 2.4 5.34 5.34s-2.4 5.34-5.34 5.34zm0-9.72c-2.41 0-4.38 1.96-4.38 4.38s1.96 4.38 4.38 4.38 4.38-1.96 4.38-4.38-1.97-4.38-4.38-4.38z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <path
                        fill="#ffffff"
                        d="M27.16 57.08c-1.1 0-1.99-.89-1.99-1.99s.89-1.99 1.99-1.99a1.989 1.989 0 1 1 0 3.98z"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#000102"
                        d="M27.16 57.56c-1.36 0-2.47-1.11-2.47-2.47s1.11-2.47 2.47-2.47 2.47 1.11 2.47 2.47-1.11 2.47-2.47 2.47zm0-3.98c-.83 0-1.51.68-1.51 1.51s.68 1.51 1.51 1.51 1.51-.68 1.51-1.51-.68-1.51-1.51-1.51z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <path
                        fill="#ffffff"
                        d="M42.32 25.73H18.19c-.95 0-1.72.77-1.72 1.72v2.61h27.58v-2.61c0-.95-.78-1.72-1.73-1.72z"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#000102"
                        d="M44.05 30.55H16.46a.48.48 0 0 1-.48-.48v-2.61c0-1.22.99-2.21 2.21-2.21h24.13c1.22 0 2.21.99 2.21 2.21v2.61c0 .26-.22.48-.48.48zm-27.11-.97h26.62v-2.12c0-.68-.56-1.24-1.24-1.24H18.19c-.68 0-1.24.56-1.24 1.24v2.12z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <path
                        fill="#c5dcf1"
                        d="M16.46 30.06h27.58v16.7H16.46z"
                        opacity={1}
                        data-original="#f4f6f8"
                        className=""
                    />
                    <path
                        fill="#d7dadf"
                        d="M16.46 45.31h27.58v1.45H16.46z"
                        opacity={1}
                        data-original="#d7dadf"
                    />
                    <path
                        fill="#000102"
                        d="M44.05 47.24H16.46a.48.48 0 0 1-.48-.48v-16.7c0-.27.22-.48.48-.48h27.58c.27 0 .48.22.48.48v16.7c.01.27-.21.48-.47.48zm-27.11-.96h26.62V30.55H16.94z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <path
                        fill="#f76c82"
                        d="M38.34 23.52c0 6.12-8.08 12.2-8.08 12.2s-8.08-6.08-8.08-12.2c0-4.46 3.62-8.08 8.08-8.08s8.08 3.61 8.08 8.08z"
                        opacity={1}
                        data-original="#f76c82"
                    />
                    <path
                        fill="#eb5463"
                        d="M38.34 23.52c0 6.12-8.09 12.21-8.09 12.21s-8.08-6.09-8.08-12.21c0-.25.01-.5.04-.75.57 5.87 8.04 11.51 8.04 11.51s7.48-5.63 8.05-11.51c.03.24.04.5.04.75z"
                        opacity={1}
                        data-original="#eb5463"
                        className=""
                    />
                    <path
                        fill="#000102"
                        d="M30.25 36.2c-.1 0-.2-.03-.29-.1-.34-.25-8.28-6.3-8.28-12.59 0-4.72 3.84-8.57 8.57-8.57s8.57 3.84 8.57 8.57c0 6.29-7.94 12.34-8.28 12.59-.08.07-.18.1-.29.1zm0-20.28c-4.19 0-7.6 3.41-7.6 7.6 0 5.16 6.17 10.44 7.6 11.59 1.43-1.15 7.6-6.43 7.6-11.59 0-4.19-3.41-7.6-7.6-7.6z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                    <path
                        fill="#ffffff"
                        d="M30.25 27.25c-2.06 0-3.74-1.68-3.74-3.74s1.68-3.74 3.74-3.74 3.74 1.68 3.74 3.74a3.74 3.74 0 0 1-3.74 3.74z"
                        opacity={1}
                        data-original="#ffffff"
                    />
                    <path
                        fill="#000102"
                        d="M30.25 27.74a4.22 4.22 0 1 1 4.22-4.22c0 2.32-1.89 4.22-4.22 4.22zm0-7.48c-1.79 0-3.25 1.46-3.25 3.25s1.46 3.25 3.25 3.25 3.25-1.46 3.25-3.25c.01-1.79-1.45-3.25-3.25-3.25z"
                        opacity={1}
                        data-original="#000102"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default TrackingIcon